import React from "react";
import { Star } from "lucide-react";
import { useLang } from "../../context/LangContext";

export default function Testimonials() {
  const { c } = useLang();
  const t = c.testimonials;
  return (
    <section className="section" style={{ background: "#0c0c0f" }}>
      <div className="container-x">
        <div className="reveal" style={{ maxWidth: 760, marginBottom: "3.5rem" }}>
          <span className="eyebrow">{t.eyebrow}</span>
          <h2 className="display" style={{ fontSize: "clamp(2.2rem,5vw,4rem)", margin: "1.2rem 0" }}>
            {t.title.pre}<span className="italic-gold">{t.title.em}</span>{t.title.post}
          </h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "1.5rem" }}>
          {t.items.map((item, i) => (
            <div key={i} className="card reveal" style={{ padding: "2.4rem", display: "flex", flexDirection: "column" }}>
              <div className="font-serif" style={{ fontSize: "3rem", color: "var(--gold)", lineHeight: 0.5, height: 24 }}>“</div>
              <div style={{ display: "flex", gap: 3, margin: "0 0 1.2rem" }}>
                {[...Array(5)].map((_, s) => <Star key={s} size={14} fill="var(--gold)" color="var(--gold)" />)}
              </div>
              <p className="body-text" style={{ color: "var(--text)", fontSize: "0.95rem", flex: 1, marginBottom: "1.8rem" }}>{item.text}</p>
              <div style={{ display: "flex", alignItems: "center", gap: "1rem", borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: "1.4rem" }}>
                <div style={{ width: 44, height: 44, borderRadius: "50%", background: "var(--gold-soft)", border: "1px solid var(--gold)", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--gold)", fontSize: "0.85rem", fontWeight: 500 }}>{item.initials}</div>
                <div>
                  <div style={{ color: "var(--text)", fontWeight: 400 }}>{item.name}</div>
                  <div style={{ color: "var(--muted-2)", fontSize: "0.78rem" }}>{item.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
